<script lang="ts">
	import LinkCard from "@components/LinkCard.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import type { ClassValue } from "svelte/elements";
	import type { Tenant } from "@core/schema/Tenant.js";
	import { getCareerPositionDetailPath } from "@core/schema/paths/getCareerPositionsDetailPath.js";
	import { careerPositionIconByKey } from "../data/careerPositionIconByKey.js";
	import type { CareerPosition } from "../data/careerPositions.js";

	const {
		tenant,
		positions,
		class: className,
	}: {
		tenant: Tenant;
		positions: CareerPosition[];
		class?: ClassValue;
	} = $props();
</script>

<div class={["flex flex-col md:flex-row gap-5", className]}>
	{#each positions as position (position.slug)}
		{#snippet desc()}
			<div class="flex flex-wrap gap-2">
				{#if position.badges?.length}
					{#each position.badges ?? [] as badge, badgeIndex (badgeIndex)}
						<span class="rounded-full bg-fstlight-100 px-3 py-1 text-[14px] text-fstgrey-200">
							<Formatted text={badge.text} />
						</span>
					{/each}
				{/if}

				{#if position.stackBadges?.length}
					{#each position.stackBadges ?? [] as stackBadge (stackBadge)}
						<span class="rounded-full bg-fstlight-100 px-3 py-1 text-[14px] text-fstgrey-200">{stackBadge}</span>
					{/each}
				{/if}
			</div>
		{/snippet}

		<LinkCard
			href={getCareerPositionDetailPath(tenant, position)}
			title={position.title}
			{desc}
			iconName={careerPositionIconByKey[position.iconKey]}
		/>
	{/each}
</div>
